import { environment } from 'environments/environment';
import { Component, inject, OnInit } from '@angular/core';
import { ReportsComponent } from 'app/shared/components/reports/reports.component';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NewReportOptionsTemplateDirective } from 'app/shared/directives/new-report-options-template.directive';
import { ReportMonthRangeOption, ReportMonthRangeOptionComponent } from 'app/shared/components/report-month-range-option/report-month-range-option.component';
import { ReportAppliedMonthRangeOptionComponent } from 'app/shared/components/report-applied-month-range-option/report-applied-month-range-option.component';
import { ReportDetailsTemplateDirective } from 'app/shared/directives/report-details-template.directive';

@Component({
  selector: 'app-capture-admin-wag-billing-api-reports',
  templateUrl: './capture-admin-wag-billing-api-reports.component.html',
  imports: [
    FormsModule,
    NewReportOptionsTemplateDirective,
    ReactiveFormsModule,
    ReportMonthRangeOptionComponent,
    ReportsComponent,
    ReportDetailsTemplateDirective,
    ReportAppliedMonthRangeOptionComponent
  ],
})
export class CaptureAdminWagBillingApiReportsComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/wag_billing_api_reports`;

  filtersForm: UntypedFormGroup;

  billingDateFilterOptions: {
    minYear: number;
    minMonth: number;
    maxYear: number;
    maxMonth: number;
  };

  ngOnInit() {
    this.setupFilters();
  }

  setupFilters() {
    const currentDate = new Date();

    const billingDateFilter = new ReportMonthRangeOption({
      fromYear: currentDate.getFullYear(),
      fromMonth: currentDate.getMonth(),
      toYear: currentDate.getFullYear(),
      toMonth: currentDate.getMonth() + 1,
    });

    this.filtersForm = this.formBuilder.group({
      billingDate: [billingDateFilter, Validators.required],
    });

    this.billingDateFilterOptions = {
      minYear: 2018,
      minMonth: 1,
      maxYear: currentDate.getFullYear(),
      maxMonth: currentDate.getMonth() + 1,
    };
  }
}
